import Avatar from "react-avatar";
import axios from "axios";
import useCookie from "../hooks/useCookie";
import { useContext } from "react";
import { ColorContext } from "../context/ColorContext";
import { EntityManagementContext } from "../context/EntityManagementContext";
import { useEffect, useState } from "react";

function TeacherRow(props) {
    const csrftoken = useCookie("csrftoken");

    const [teacherClasses, setTeacherClasses] = useState([]);

    const { blue, white } = useContext(ColorContext);
    const {
        setMode,
        setEditingID,
        openPopup,
        teachers,
        classes,
        setTeachers,
        setClasses
    } = useContext(EntityManagementContext);

    // Headers for requests
    const headers = {
        "X-CSRFToken": csrftoken,
    };

    useEffect(() => {
        getClassNames(props.classes);
    }, [props.classes]);

    const getClassNames = (classIDs) => {
        let temporary = [];
        classIDs.forEach((classID) => {
            axios
            .get("/api/classes/" + classID)
            .then((response) => {
                let classObj = response.data;
                temporary.push(classObj.className);
                setTeacherClasses(temporary);
                return;
            });
        });
        // Set classes to empty list if teacher has no class IDs
        setTeacherClasses(temporary);
    }

    // When the user elects to edit this teacher record (via button press), switch
    // mode to "Edit", specify this as the target ID, and open management popup,
    // if layout necessitates it
    const editTeacher = () => {
        setMode("Edit");
        setEditingID(props.id);
        openPopup(); // If page is narrow, open popup
    }

    // When user elects to delete this teacher record, confirm their
    // choice, then remove this record from the teacher state variable
    const deleteTeacher = (event) => {
        event.preventDefault();

        let deletionConfirmation = false;

        deletionConfirmation = window.confirm(
            `\nDelete ${props.name}?\nPress OK to confirm, or cancel this action.`
        )

        if (deletionConfirmation) {
            axios
            .delete(`/api/teachers/${props.id}/`, { headers })
            .then(() => {
                // Delete all classes of this teacher
                let mutableClasses = classes;
                setClasses(mutableClasses.filter(
                    myClass => !props.classes.includes(myClass.classID)
                ));

                // Delete teacher from teachers list
                let mutableTeachers = teachers;
                mutableTeachers = mutableTeachers.filter(teacher => teacher.id != props.id);
                setTeachers(mutableTeachers);
            })
            .catch((error) => console.error(error));
        }
    }

    return (
        <>
            <td>
                <Avatar name={props.name} round={true} size="50" color={blue} fgColor={white} /> {/* Profile picture */}
                {props.name} {/* Name */}
            </td>
            <td>
                {props.email} {/* Email */}
            </td>
            <td>
                {teacherClasses.map(classObj => {
                    return <p style={{padding: "0", margin: "0", fontStyle: "italic"}}>{classObj}</p>
                })}
            </td>
            <td> {/* Actions */}
                <button onClick={editTeacher}>Edit</button> {/* Edit button */}
                <button onClick={deleteTeacher}>Delete</button> {/* Delete button */}
            </td>
        </>
    );
}

export default TeacherRow;